import React from "react";
import PolicyLayout from "@/components/PolicyLayout";

export default function Returns() {
  return (
    <PolicyLayout
      title="Returns &amp; refunds"
      description="14-day right to cancel under UK Consumer Contracts Regulations. Full refund within 14 days of receipt."
      path="/returns"
      eyebrow="Returns"
      lastUpdated="February 2026"
    >
      <h2>Your right to cancel</h2>
      <p>
        Under the UK <strong>Consumer Contracts (Information, Cancellation and Additional
        Charges) Regulations 2013</strong>, you have the right to cancel your order within{" "}
        <strong>14 days of receiving your PeptiChill</strong>, for any reason.
      </p>

      <h2>Condition requirements</h2>
      <p>
        To be eligible for a full refund, the PeptiChill must be returned to us:
      </p>
      <ul>
        <li>Unused and in the same condition you received it</li>
        <li>In its original packaging with all accessories included</li>
        <li>Within <strong>14 days of notifying us</strong> of your cancellation</li>
      </ul>
      <p>
        If the goods are returned damaged or in a condition reflecting handling beyond what
        was necessary to inspect them, we may reduce the refund to reflect any loss in value.
      </p>

      <h2>How to start a return</h2>
      <p>
        Email <a href="mailto:hello@peptidecooler.co.uk">hello@peptidecooler.co.uk</a> with
        your order reference and we&rsquo;ll provide return instructions and a return address.
        Please don&rsquo;t send the item back without contacting us first — it helps us
        process your refund quickly.
      </p>

      <h2>Return shipping</h2>
      <p>
        Unless the item is faulty or was sent in error, the cost of returning the product is
        your responsibility. We strongly recommend using a tracked service, as we cannot
        refund items lost in transit on the way back to us.
      </p>

      <h2>Refund timeline</h2>
      <p>
        Once we&rsquo;ve received and inspected your return, we&rsquo;ll process your refund
        within <strong>14 days</strong> to the original payment method. Card refunds
        typically clear within 3–5 working days from processing, depending on your bank.
      </p>

      <h2>Faulty or incorrect items</h2>
      <p>
        Your statutory rights under the <strong>Consumer Rights Act 2015</strong> are
        unaffected. If your PeptiChill is faulty, not as described, or not fit for purpose,
        contact us within 30 days and we&rsquo;ll arrange a free return and a replacement or
        full refund.
      </p>

      <h2>Return address</h2>
      <p>
        {/* [REVIEW – confirm final return warehouse address] */}
        We&rsquo;ll provide the current return address with your return authorisation. Please
        do not send returns to our registered office.
      </p>
    </PolicyLayout>
  );
}
